import { Component, OnInit, Input } from '@angular/core';
import { IPreorderResponse } from '../shared/interfaces/data-micro-ui-interface';
import * as moment from 'moment';

@Component({
  selector: 'pre-order-banner',
  templateUrl: './pre-order-banner.component.html',
  styleUrls: ['./pre-order-banner.component.scss']
})
export class PreOrderBannerComponent  {

  public date: string;
  public shrinkMargin : boolean;
  public location: string;
  public closed : boolean;

  @Input() product: string;
  @Input()
  set preOrderDate(preDate: IPreorderResponse) {
    if (preDate && preDate.preOrderEnabled) {
      const yearMontDayDate = preDate.preOrderBannerDateTime.split(' ');
      const date = moment(yearMontDayDate[0], "MM DD YYYY");
      this.date = this.formatDate(date.format('ll'), 3, 0, ".");
    }
  }
  @Input()
  set margin(margin: boolean){
      this.shrinkMargin = margin;
  }

  showBanner() {
    if (["/terms/autorenewal", "/terms/taxidentityshield",
      "/autorenewal", "/taxidentityshield"].some(e => e === this.location)) {
      return false;
    } else if(this.closed) {
      return false;
    } else if ( this.date === "") {
      return false;
    } else {
      return true;
    }
  }

  constructor() {
    this.location = window.location.pathname;
    this.closed = false;
    this.date = "";
   }


  //Add characters to date
  formatDate(string, idx, rem, str) {
    return string.slice(0, idx) + str + string.slice(idx + Math.abs(rem));
  };

  closeBanner() {
    this.closed = true;
   /*  const banner = document.getElementsByClassName('pre-order-banner-container')[0];
    (<HTMLElement>banner).style.marginTop = "-80px"; */
    //gives time for the animation to show and then sets the banner as closed
    /* setTimeout(() => {
      this.closed = true;
    }, 1500) */
  }

}
